/**
 * 匹配并提取 label 和 value
 * @param input 输入字符串，如 "姓名: xxx"
 * @returns 返回包含 label 和 value 的对象，如果格式不匹配则返回 null
 */
export function parseTag(input: string): { label: string; value: string } | null {
  if (!input || typeof input !== 'string') {
    return null;
  }

  const colonMatch = input.match(/^([^:：]+)[:：]\s*(.*)$/);

  if (!colonMatch) {
    return null;
  }

  const label = colonMatch[1].trim();
  const value = colonMatch[2].trim();

  if (!label) {
    return null;
  }

  return { label, value };
}

// const s1 = '姓名: 张三'
// const s2 = '年龄: 18'
// const s3 = '性别: 男'
// const s4 = '姓名：   全家福：123'
// const s5 = '全家福123'

// console.log(parseTag(s1)) // { label: '姓名', value: '张三' }
// console.log(parseTag(s2)) // { label: '年龄', value: '18' }
// console.log(parseTag(s3)) // { label: '性别', value: '男' }
// console.log(parseTag(s4)) // { label: '姓名', value: '全家福：123' }
// console.log(parseTag(s5)) // null
